import React, { useCallback } from 'react';
import {
  CELL_RENDERERS
} from 'cdk-radial';
import { AgGridReact } from 'ag-grid-react';
import {
  TableContainer,
  TableContent,
  usePreventTableScrollingRef,
} from 'cdk-radial';
import { dmsConfigsTableClass, frameworkComponentsExtended } from '../tableUtils';
import './DMSConfigTable.scss';

const headers = {
  type: 'Account Type',
  name: 'Department Name',
  id: 'Department ID',
};

const DMSTable = ({departments = []}) => {
  const tableContentRef = usePreventTableScrollingRef();

  const handleGridReady = useCallback(gridParams => {
    gridParams.api.sizeColumnsToFit();
  }, []);

  const columns = [
    {
      field: 'dmsType'
    },
    {
      field: 'name'
    },
    {
      field: 'id'
    }
  ];

  const styledColumns = columns.map(c => ({
      ...c,
      headerName: headers[c?.field],
      cellRenderer: CELL_RENDERERS.TEXT,
      sortable: true,
      headerClass: 'column-header',
      tooltipField: c?.field
    }
  ));

  return (
    <TableContainer className={dmsConfigsTableClass}>
      <TableContent ref={tableContentRef}>
          <AgGridReact
              defaultColDef={{
                  filter: true,
                  sortable: true
              }}
              frameworkComponents={frameworkComponentsExtended}
              columnDefs={styledColumns}
              onGridReady={handleGridReady}
              rowData={departments}
              rowHeight={40}
              domLayout='autoHeight'
              cacheQuickFilter={true}
              pagination={true}
              paginationPageSize={5}
          />
      </TableContent>
    </TableContainer>
  );
};

export const DmsConfigTable = React.memo(DMSTable);
